import Swiper from 'swiper/bundle';

export default class Carousel {
  constructor(element) {
    this.element = element;
    this.options = {
      //les options de base du carousel
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: false,
      loop: false,

      pagination: {
        el: this.element.querySelector('.swiper-pagination'), //instanciation de la pagination
      },

      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'), //instanciation de la navigation
        prevEl: this.element.querySelector('.swiper-button-prev'),
      },

      scrollbar: {
        el: this.element.querySelector('.swiper-scrollbar'), //intanciation de la barre de défilement
      },
    };
    this.init();
  }

  init() {
    this.checkOptions(); //appelle la vérification des autres options
    new Swiper(this.element, this.options); //instancie un carousel avec les options
  }

  checkOptions() {
    const variant = this.element.dataset.variant; //représente le data-variant d'un carousel
    if (variant == 'split') {
      //si c'est une variante, change les options
      this.options.slidesPerView = 1.5;
    }

    if (variant == 'coverflow'){
      this.options = {
        effect: "coverflow",
        loop: true,
        breakpoints: {
          // when window width is >= 320px
          575: {
            slidesPerView: 1,
            
          },
          // when window width is >= 480px
          576: {
            slidesPerView: 2,
            spaceBetween: 15,
          },

          768: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          // when window width is >= 640px
          1165: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        }
        
      }

      
    }

    if ('many' in this.element.dataset) {
      //si le carousel contient un data-..., octroie des paramètres
      this.options.slidesPerView = this.element.dataset.many;
      this.options.breakpoints = {
        375: {
          slidesPerView: 1,
        },

        768: {
          slidesPerView: 2,
        },

        1024: {
          slidesPerView: parseFloat(this.element.dataset.many),
        },
      };
    }

    if ('autoplay' in this.element.dataset) {
      //si le carousel contient un data-..., octroie des paramètres
      this.options.autoplay = true;
      this.options.autoplay = {
        disableOnInteraction: false,
        speed: 660,
      };
    }

    if ('loop' in this.element.dataset) {
      this.options.loop = true;
    }

    if (variant == 'accueil'){
      this.options = {
        
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        mousewheel: true,
        direction: "vertical",
        parallax: true,
        
        
      }
    }

    }
  
}
